function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 7.68301,
  y: 134.183,
  width: 53,
  height: 35,
  rx: 4.5,
  transform: "rotate(-30 7.68301 134.183)",
  stroke: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.1602 134.33L39.83 141.83L35.4999 134.33L44.1602 134.33Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 311.394,
  y: 248.236,
  width: 43.1903,
  height: 28.4602,
  rx: 4.5,
  transform: "rotate(15 311.394 248.236)",
  stroke: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M332.352 269.318L325.507 271.152L327.341 264.306L332.352 269.318Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M274.032 74.7648C274.792 75.6347 274.325 77.0004 273.192 77.2231L259.595 79.8952C258.462 80.1179 257.513 79.0305 257.887 77.938L262.371 64.8272C262.744 63.7346 264.161 63.4562 264.92 64.3261L274.032 74.7648Z",
  stroke: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.8356 243.339C28.9752 243.153 29.8893 244.27 29.4811 245.35L24.5828 258.312C24.1746 259.392 22.7501 259.625 22.0188 258.732L13.2428 248.009C12.5115 247.115 13.0218 245.765 14.1613 245.578L27.8356 243.339Z",
  stroke: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M296.741 82.5314C297.501 83.4013 297.034 84.767 295.9 84.9897L282.304 87.6618C281.171 87.8845 280.222 86.7971 280.596 85.7046L285.08 72.5938C285.453 71.5012 286.87 71.2228 287.629 72.0927L296.741 82.5314Z",
  stroke: "white"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M312.538 154.424C312.708 154.012 313.292 154.012 313.462 154.424L314.429 156.759C314.581 157.127 314.873 157.419 315.241 157.571L317.576 158.538C317.988 158.708 317.988 159.292 317.576 159.462L315.241 160.429C314.873 160.581 314.581 160.873 314.429 161.241L313.462 163.576C313.292 163.988 312.708 163.988 312.538 163.576L311.571 161.241C311.419 160.873 311.127 160.581 310.759 160.429L308.424 159.462C308.012 159.292 308.012 158.708 308.424 158.538L310.759 157.571C311.127 157.419 311.419 157.127 311.571 156.759L312.538 154.424Z",
  stroke: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M101.087 113.44C101.001 113.003 101.487 112.681 101.857 112.93L103.953 114.343C104.283 114.565 104.688 114.647 105.079 114.571L107.559 114.087C107.997 114.001 108.319 114.488 108.07 114.857L106.657 116.953C106.434 117.283 106.352 117.688 106.429 118.079L106.913 120.56C106.998 120.997 106.512 121.319 106.143 121.07L104.047 119.657C103.717 119.435 103.312 119.353 102.921 119.429L100.44 119.913C100.003 119.998 99.6806 119.512 99.9297 119.143L101.342 117.047C101.565 116.717 101.647 116.312 101.571 115.921L101.087 113.44Z",
  stroke: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M73.1139 272.568C73.3613 272.197 73.9332 272.311 74.0201 272.748L75.215 278.757C75.2926 279.148 75.5223 279.491 75.8534 279.712L80.9493 283.114C81.3199 283.362 81.2062 283.934 80.7692 284.02L74.7598 285.215C74.3694 285.293 74.0258 285.523 73.8048 285.854L70.403 290.95C70.1556 291.32 69.5837 291.207 69.4968 290.77L68.3019 284.76C68.2243 284.37 67.9946 284.026 67.6635 283.805L62.5676 280.403C62.197 280.156 62.3107 279.584 62.7477 279.497L68.7571 278.302C69.1475 278.225 69.4911 277.995 69.7121 277.664L73.1139 272.568Z",
  stroke: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194.5 205C208.583 205 220 193.583 220 179.5C220 165.417 208.583 154 194.5 154C180.417 154 169 165.417 169 179.5C169 193.583 180.417 205 194.5 205ZM194.5 208C210.24 208 223 195.24 223 179.5C223 163.76 210.24 151 194.5 151C178.76 151 166 163.76 166 179.5C166 195.24 178.76 208 194.5 208Z",
  fill: "#989898"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M146 204C157.046 204 166 195.046 166 184C166 172.954 157.046 164 146 164C134.954 164 126 172.954 126 184C126 195.046 134.954 204 146 204ZM146 207C158.703 207 169 196.703 169 184C169 171.297 158.703 161 146 161C133.297 161 123 171.297 123 184C123 196.703 133.297 207 146 207Z",
  fill: "#989898"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M194 186C197.866 186 201 182.866 201 179C201 175.134 197.866 172 194 172C190.134 172 187 175.134 187 179C187 182.866 190.134 186 194 186ZM194 189C199.523 189 204 184.523 204 179C204 173.477 199.523 169 194 169C188.477 169 184 173.477 184 179C184 184.523 188.477 189 194 189Z",
  fill: "#989898"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M146 189C148.761 189 151 186.761 151 184C151 181.239 148.761 179 146 179C143.239 179 141 181.239 141 184C141 186.761 143.239 189 146 189ZM146 192C150.418 192 154 188.418 154 184C154 179.582 150.418 176 146 176C141.582 176 138 179.582 138 184C138 188.418 141.582 192 146 192Z",
  fill: "#989898"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143 219.5C143 218.672 143.672 218 144.5 218H200.5C201.328 218 202 218.672 202 219.5C202 220.328 201.328 221 200.5 221H144.5C143.672 221 143 220.328 143 219.5Z",
  fill: "#989898"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M149.622 284.399C148.86 284.072 148.508 283.19 148.834 282.429L162.652 250.197C162.979 249.435 163.86 249.082 164.622 249.409C165.383 249.735 165.736 250.617 165.409 251.379L151.591 283.611C151.265 284.372 150.383 284.725 149.622 284.399Z",
  fill: "#989898"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M195.621 284.591C194.859 284.917 193.978 284.564 193.651 283.803L179.833 251.56C179.507 250.799 179.859 249.917 180.621 249.591C181.382 249.264 182.264 249.617 182.591 250.379L196.409 282.621C196.735 283.383 196.382 284.264 195.621 284.591Z",
  fill: "#989898"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M160.5 198H176.5V201H160L160.5 198Z",
  fill: "#989898"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M212.5 213V201L209.5 202V248C209.5 248.276 209.276 248.5 209 248.5H136C135.724 248.5 135.5 248.276 135.5 248V203.516L132.5 202.5V212H128.5C126.567 212 125 213.567 125 215.5V226.5C125 228.433 126.567 230 128.5 230H132.5V248C132.5 249.933 134.067 251.5 136 251.5H209C210.933 251.5 212.5 249.933 212.5 248V236H218C219.665 236 221.058 234.838 221.413 233.281L229 236.695V237C229 238.933 230.567 240.5 232.5 240.5H237.5C239.433 240.5 241 238.933 241 237V212C241 210.067 239.433 208.5 237.5 208.5H232.5C230.567 208.5 229 210.067 229 212V213.284L221.494 216.287C221.384 214.453 219.861 213 218 213H212.5ZM221.5 219.516V230.03L229 233.405V216.516L221.5 219.516ZM212.5 233H218C218.276 233 218.5 232.776 218.5 232.5V216.5C218.5 216.224 218.276 216 218 216H212.5V233ZM132.5 227V215H128.5C128.224 215 128 215.224 128 215.5V226.5C128 226.776 128.224 227 128.5 227H132.5ZM232.5 211.5C232.224 211.5 232 211.724 232 212V237C232 237.276 232.224 237.5 232.5 237.5H237.5C237.776 237.5 238 237.276 238 237V212C238 211.724 237.776 211.5 237.5 211.5H232.5Z",
  fill: "#989898"
});

var SvgCreateNewProject = function SvgCreateNewProject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 334,
    viewBox: "0 0 365 334",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateNewProject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create_new_project.cfacf821.svg";
export { ForwardRef as ReactComponent };